@if (tagLabel()) {
<div
  class="tag-wrapper"
  [ngClass]="tagClasses()"
>
  <label class="tag-label">{{ tagLabel() | titlecase }}</label>
</div>
}
